document.documentElement.classList.remove('no-js');
const rreToast=(message)=>{const el=document.getElementById('RreToast');if(!el)return;el.textContent=message;el.classList.add('show');clearTimeout(window.rreToastTimer);window.rreToastTimer=setTimeout(()=>el.classList.remove('show'),1800)};
document.addEventListener('click',event=>{
  const toggle=event.target.closest('[data-menu-toggle]');
  if(toggle){const menu=document.getElementById('MobileMenu');const open=menu.toggleAttribute('open');toggle.setAttribute('aria-expanded',String(open));}
});
document.querySelectorAll('.reviews-section').forEach(section=>{
  const track=section.querySelector('[data-review-track]');
  if(!track)return;
  const move=direction=>track.scrollBy({left:direction*Math.min(410,track.clientWidth*.85),behavior:'smooth'});
  section.querySelector('[data-review-prev]')?.addEventListener('click',()=>move(-1));
  section.querySelector('[data-review-next]')?.addEventListener('click',()=>move(1));
  const autoplay=()=>setInterval(()=>{if(track.scrollLeft+track.clientWidth>=track.scrollWidth-10)track.scrollTo({left:0,behavior:'smooth'});else move(1)},5500);
  let timer=autoplay();
  section.addEventListener('mouseenter',()=>clearInterval(timer));
  section.addEventListener('mouseleave',()=>{clearInterval(timer);timer=autoplay()});
});
document.querySelectorAll('.featured-carousel-section').forEach(section=>{
  const track=section.querySelector('[data-product-carousel]');
  if(!track)return;
  const move=direction=>track.scrollBy({left:direction*Math.min(620,track.clientWidth*.9),behavior:'smooth'});
  section.querySelector('[data-carousel-prev]')?.addEventListener('click',()=>move(-1));
  section.querySelector('[data-carousel-next]')?.addEventListener('click',()=>move(1));
});
document.querySelectorAll('[data-product-gallery]').forEach(gallery=>{
  const items=[...gallery.querySelectorAll('[data-gallery-image]')];
  const lightbox=document.querySelector('[data-product-lightbox]');
  if(!items.length||!lightbox)return;
  const image=lightbox.querySelector('[data-lightbox-image]');
  const closeButton=lightbox.querySelector('[data-lightbox-close]');
  const previousButton=lightbox.querySelector('[data-lightbox-prev]');
  const nextButton=lightbox.querySelector('[data-lightbox-next]');
  let currentIndex=0;
  let opener=null;
  const show=index=>{
    currentIndex=(index+items.length)%items.length;
    const thumbnail=items[currentIndex].querySelector('img');
    image.src=items[currentIndex].dataset.fullImage;
    image.alt=thumbnail?.alt||'';
  };
  const open=(index,button)=>{
    opener=button;
    show(index);
    lightbox.hidden=false;
    document.body.classList.add('lightbox-open');
    closeButton.focus();
  };
  const close=()=>{
    lightbox.hidden=true;
    image.src='';
    document.body.classList.remove('lightbox-open');
    opener?.focus();
  };
  items.forEach((item,index)=>item.addEventListener('click',()=>open(index,item)));
  closeButton.addEventListener('click',close);
  previousButton.addEventListener('click',()=>show(currentIndex-1));
  nextButton.addEventListener('click',()=>show(currentIndex+1));
  lightbox.addEventListener('click',event=>{if(event.target===lightbox||event.target.classList.contains('product-lightbox-stage'))close()});
  document.addEventListener('keydown',event=>{
    if(lightbox.hidden)return;
    if(event.key==='Escape')close();
    if(event.key==='ArrowLeft')show(currentIndex-1);
    if(event.key==='ArrowRight')show(currentIndex+1);
  });
  if(items.length<2){previousButton.hidden=true;nextButton.hidden=true;}
});
document.addEventListener('submit',async event=>{
  const form=event.target.closest('form[data-ajax-cart]');
  if(!form)return;
  event.preventDefault();
  const button=form.querySelector('[type="submit"]');
  button?.setAttribute('disabled','');
  try{
    const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
    if(!response.ok)throw new Error((await response.json()).description||'Unable to add item');
    const cart=await fetch(window.Shopify.routes.root+'cart.js').then(r=>r.json());
    document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
    rreToast('Added to cart');
  }catch(error){rreToast(error.message)}finally{button?.removeAttribute('disabled')}
});



// Clicklease estimated-payment offer for eligible products.
(() => {
  'use strict';

  const LANDING_URL = 'https://www.clicklease.com/partner/rockhold-ranch-equipment';
  const API_URL = 'https://app.clicklease.com/api/estimatedPaymentAmount/';
  const MIN_PRICE = 500;
  const MAX_PRICE = 30000;
  let renderTimer;

  const scheduleRender = () => {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(render, 300);
  };

  setTimeout(render, 500);
  document.addEventListener('shopify:section:load', scheduleRender);

  const observer = new MutationObserver(scheduleRender);
  observer.observe(document.body, { childList: true, subtree: true });

  function render() {
    document
      .querySelectorAll('[data-product-price], .product-card .price')
      .forEach(addPaymentOffer);
  }

  function addPaymentOffer(priceElement) {
    const amount = parsePrice(priceElement);
    const scope =
      priceElement.closest('.product-card-info, .product-info') ||
      priceElement.parentElement ||
      priceElement;
    const existing = scope.querySelector('.ClkButton');
    const fallback = scope.querySelector('.clicklease-link');

    if (!Number.isFinite(amount) || amount < MIN_PRICE || amount > MAX_PRICE) {
      existing?.remove();
      if (fallback) fallback.style.removeProperty('display');
      delete priceElement.dataset.clkPending;
      return;
    }

    if (existing?.dataset.clkAmount === String(amount)) {
      if (fallback) fallback.style.setProperty('display', 'none', 'important');
      return;
    }

    if (priceElement.dataset.clkPending === String(amount)) return;
    priceElement.dataset.clkPending = String(amount);

    fetch(API_URL + encodeURIComponent(amount), {
      method: 'GET',
      headers: { Accept: 'application/json' }
    })
      .then((response) => {
        if (!response.ok) throw new Error('Clicklease request failed');
        return response.json();
      })
      .then((payload) => {
        delete priceElement.dataset.clkPending;

        // Ignore a response if a variant changed while the request was running.
        if (parsePrice(priceElement) !== amount) {
          scheduleRender();
          return;
        }

        const payment = Number(payload?.object);
        if (!Number.isFinite(payment) || payment <= 0) {
          throw new Error('Invalid Clicklease payment');
        }

        const monthlyPayment = payment.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        const offer = buildOffer(amount, monthlyPayment);

        if (existing) existing.replaceWith(offer);
        else priceElement.after(offer);

        if (fallback) fallback.style.setProperty('display', 'none', 'important');
      })
      .catch(() => {
        delete priceElement.dataset.clkPending;
        const currentAmount = parsePrice(priceElement);
        if (existing && existing.dataset.clkAmount !== String(currentAmount)) {
          existing.remove();
        }
        if (fallback) fallback.style.removeProperty('display');
      });
  }

  function buildOffer(amount, monthlyPayment) {
    const wrapper = document.createElement('div');
    wrapper.className = 'ClkButton';
    wrapper.dataset.clkAmount = String(amount);
    wrapper.style.cssText = 'width:100%;max-width:500px;margin:10px 0;';

    const link = document.createElement('a');
    link.href = LANDING_URL;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.setAttribute(
      'aria-label',
      'Apply with Clicklease. Estimated payment as low as $' +
        monthlyPayment +
        ' per month.'
    );
    link.style.cssText =
      'display:flex;align-items:center;justify-content:space-between;gap:12px;' +
      'width:100%;min-height:56px;padding:10px 12px;border:1px solid #d9e8ef;' +
      'border-radius:8px;background:#fff;text-decoration:none;box-sizing:border-box;' +
      'font-family:Segoe UI,Helvetica Neue,Arial,sans-serif;';

    const message = document.createElement('span');
    message.style.cssText =
      'color:#222;font-size:17px;line-height:1.25;letter-spacing:.1px;';
    message.append('Business equipment financing as low as ');

    const price = document.createElement('strong');
    price.style.color = '#02adee';
    price.textContent = '$' + monthlyPayment + '/mo';
    message.append(price, ' with ');

    const brand = document.createElement('strong');
    brand.style.cssText = 'font-size:19px;white-space:nowrap;';
    const click = document.createElement('span');
    click.style.color = '#02adee';
    click.textContent = 'click';
    const lease = document.createElement('span');
    lease.style.color = '#555';
    lease.textContent = 'lease';
    brand.append(click, lease);
    message.append(brand);

    const apply = document.createElement('span');
    apply.textContent = 'APPLY NOW';
    apply.style.cssText =
      'flex:0 0 auto;padding:8px 13px;border-radius:999px;background:#20b6f1;' +
      'color:#fff;font-size:12px;font-weight:700;letter-spacing:1px;white-space:nowrap;';

    link.append(message, apply);
    wrapper.append(link);
    return wrapper;
  }

  function parsePrice(element) {
    const clone = element.cloneNode(true);
    clone
      .querySelectorAll('.compare-price, .compare-at, s, del')
      .forEach((node) => node.remove());

    const text = (clone.textContent || '').replace(/\s/g, '');
    const match = text.match(/\$?([\d,]+(?:\.\d{1,2})?)/);
    if (match) {
      return Number(match[1].replace(/,/g, ''));
    }

    const attribute = Number(element.getAttribute?.('data-product-price'));
    return attribute ? attribute / 100 : NaN;
  }
})();
